export default {
  data() {
    return {
      ecofrostHeaders: [
        {
          text: 'Timestamp',
          value: 'createdAt',
          sortable: true
        },
        { text: 'SIM status', value: 'Sim_Stat', sortable: false },
        { text: 'Telecom Service Provider', value: 'TSP', sortable: false },
        { text: 'Access Point Name', value: 'APN', sortable: false },
        { text: 'Signal Strength', value: 'Signal_st', sortable: false },
        {
          text: 'Datalog interval (server)',
          value: 'Datalog_Int',
          sortable: false
        },
        { text: 'Lattitude', value: 'Lat', sortable: false },
        { text: 'Longitude', value: 'Lng', sortable: false },
        {
          text: 'SIM Integrated Circuit Card Identifier',
          value: 'ICCID',
          sortable: false
        },
        { text: 'Datalogging Failure Reason', value: 'DFR', sortable: false },
        { text: 'Read crop table', value: 'Read_Crp', sortable: false },
        { text: 'Add crop', value: 'Add_Crp', sortable: false },
        { text: 'Remove crop', value: 'Rem_Crp', sortable: false },
        {
          text: 'Quectel Application Software Version',
          value: 'M66_ASV',
          sortable: false
        },
        {
          text: 'Quectel Base Software Version',
          value: 'M66_BSV',
          sortable: false
        },
        { text: 'System number', value: 'Sys_Num', sortable: false },
        {
          text: 'Customer Phone number',
          value: 'Cstmr_Ph_No',
          sortable: false
        },
        { text: 'Communication Status', value: 'Comm_Status', sortable: false },
        { text: 'M66 Uptime', value: 'Res_M_1', sortable: false },
        { text: 'M66 Reset', value: 'Res_M_2', sortable: false },
        { text: 'Reserved M66 4', value: 'Res_M_3', sortable: false },
        { text: 'Reserved M66 5', value: 'Res_M_4', sortable: false },
        { text: 'Reserved M66 6', value: 'Res_M_5', sortable: false },
        { text: 'Reserved M66 7', value: 'Res_M_6', sortable: false },
        { text: 'Reserved M66 8', value: 'Res_M_7', sortable: false },
        { text: 'Reserved M66 9', value: 'Res_M_8', sortable: false },
        { text: 'Reserved M66 10', value: 'Res_M_9', sortable: false },
        { text: 'Reserved M66 11', value: 'Res_M_10', sortable: false },
        { text: 'Reserved M66 12', value: 'Res_M_11', sortable: false },
        { text: 'Reserved M66 13', value: 'Res_M_12', sortable: false },
        { text: 'Reserved M66 14', value: 'Res_M_13', sortable: false },
        { text: 'Reserved M66 15', value: 'Res_M_14', sortable: false },
        { text: 'Precooling mode', value: 'Precooling_M', sortable: false },
        { text: 'Power Input', value: 'Pwr_I', sortable: false },
        { text: 'Power source mode', value: 'PSM', sortable: false },
        { text: 'Room 1 temperature', value: 'Room_1_T', sortable: false },
        { text: 'Room 1 humidity', value: 'Room_1_H', sortable: false },
        { text: 'Set temperature', value: 'Set_T', sortable: false },
        { text: 'Set humidity', value: 'Set_H', sortable: false },
        { text: 'Latest Crop', value: 'Crop', sortable: false },
        { text: 'Latest Weight', value: 'Weight', sortable: false },
        { text: 'HMI rolling message', value: 'HRM', sortable: false },
        { text: 'PIC32 software version', value: 'PIC32_Sv', sortable: false },
        { text: 'Buck software version', value: 'Buck_Sv', sortable: false },
        {
          text: 'Last PIC32 code crash address',
          value: 'Crash_Addr',
          sortable: false
        },
        {
          text: 'Last PIC32 reset reason',
          value: 'Rst_Reason',
          sortable: false
        },
        { text: 'RTC ', value: 'RTC', sortable: false },
        { text: 'PCB compoenents failure', value: 'PCB_C_F', sortable: false },
        { text: 'Current filesize ', value: 'Filesize', sortable: false },
        { text: 'TES charge %', value: 'TES_Charge', sortable: false },
        { text: 'Solar Energy consumed', value: 'S_Cnsmptn', sortable: false },
        { text: 'Grid Energy consumed', value: 'G_Cnsmptn', sortable: false },
        { text: 'System uptime', value: 'Uptime', sortable: false },
        { text: 'Drive write parameter', value: 'D_wp', sortable: false },
        { text: 'Drive read parameter', value: 'D_rp', sortable: false },
        { text: 'Solar input voltage', value: 'Solar_IV', sortable: false },
        { text: 'Solar input current', value: 'Solar_IC', sortable: false },
        { text: 'Buck input voltage', value: 'Buck_IV', sortable: false },
        { text: 'Buck input current ', value: 'Buck_IC', sortable: false },
        { text: 'Buck output current', value: 'Buck_OC', sortable: false },
        { text: 'Buck faults', value: 'Buck_Flt', sortable: false },
        { text: 'Buck heatsink temp', value: 'Buck_HS_Tmp', sortable: false },
        { text: 'Battery Charging current', value: 'Bat_CC', sortable: false },
        { text: 'Battery load current', value: 'Bat_LC', sortable: false },
        { text: 'Battery Voltage', value: 'Bat_V', sortable: false },
        { text: 'VFD output power', value: 'VFD_OP', sortable: false },
        { text: 'VFD output frequency', value: 'VFD_OF', sortable: false },
        { text: 'DC bus voltage', value: 'VFD_DCV', sortable: false },
        { text: 'VFD output current', value: 'VFD_OC', sortable: false },
        { text: 'VFD fault 1', value: 'VFD_Flt1', sortable: false },
        { text: 'VFD fault 2', value: 'VFD_Flt2', sortable: false },
        { text: 'VFD fault 3', value: 'VFD_Flt3', sortable: false },
        { text: 'VFD alarm 1', value: 'VFD_Alm1', sortable: false },
        { text: 'VFD alarm 2', value: 'VFD_Alm2', sortable: false },
        { text: 'VFD DI Status', value: 'VFD_DI_Status', sortable: false },
        { text: 'VFD IGBT temp ', value: 'VFD_IGBT_Tmp', sortable: false },
        {
          text: 'VFD reference frequency',
          value: 'VFD_Ref_Frq',
          sortable: false
        },
        { text: 'R phase voltage', value: 'R_Ph_V', sortable: false },
        { text: 'Y phase voltage', value: 'Y_Ph_V', sortable: false },
        { text: 'B phase voltage', value: 'B_Ph_V', sortable: false },
        { text: 'Room 2 temperature', value: 'Room_2_T', sortable: false },
        { text: 'Room 2 humidity', value: 'Room_2_H', sortable: false },
        { text: 'Ambient temperature', value: 'Amb_T', sortable: false },
        { text: 'Ambient humidity', value: 'Amb_H', sortable: false },
        { text: 'TES-1 Temperature', value: 'TES1_T', sortable: false },
        { text: 'TES-2 Temperature', value: 'TES2_T', sortable: false },
        { text: 'TES-3 Temperature', value: 'TES3_T', sortable: false },
        { text: 'TES-4 Temperature', value: 'TES4_T', sortable: false },
        { text: 'TES-5 Temperature', value: 'TES5_T', sortable: false },
        { text: 'TES-6 Temperature', value: 'TES6_T', sortable: false },
        { text: 'Discharge Pressure', value: 'Dis_P', sortable: false },
        {
          text: 'State of each control loop ',
          value: 'Ctr_Loop_State',
          sortable: false
        },
        { text: 'Communication status', value: 'Com_Stat', sortable: false },
        { text: 'uSD card status', value: 'uSD_Stat', sortable: false },
        { text: 'C-run count', value: 'CRUN_Count', sortable: false },
        { text: 'Reason for last trip', value: 'Rsn_Lst_Trp', sortable: false },
        { text: 'Door status', value: 'Door_Stat', sortable: false },
        {
          text: 'Water level status',
          value: 'Water_Lvl_Stat',
          sortable: false
        },
        { text: 'Room LED status', value: 'Room_Led_Stat', sortable: false },
        { text: 'Ref. faults', value: 'Ref_Flt', sortable: false },
        { text: 'R-01 CDU F1', value: 'R_01', sortable: false },
        { text: 'R-02 CDU F2 ', value: 'R_02', sortable: false },
        { text: 'R-03 CDU F3', value: 'R_03', sortable: false },
        { text: 'R-04 CDU F4', value: 'R_04', sortable: false },
        { text: 'R-05 FCU F1', value: 'R_05_Buck', sortable: false },
        { text: 'R-06 FCU F2', value: 'R_06', sortable: false },
        { text: 'R-07 FCU F3', value: 'R_07_DG_off', sortable: false },
        { text: 'R-08 Humidifier', value: 'R_08_DG_on', sortable: false },
        { text: 'R-09 TV4', value: 'R_09', sortable: false },
        { text: 'R-10 TV3', value: 'R_10', sortable: false },
        { text: 'R-11 TV2', value: 'R_11', sortable: false },
        { text: 'R-12 TV1', value: 'R_12', sortable: false },
        { text: 'R-13 FV', value: 'R_13_HTR', sortable: false },
        { text: 'R-14 DG ON', value: 'R_14_HUM', sortable: false },
        { text: 'R-15 DG OFF', value: 'R_15_PBF', sortable: false },
        { text: 'R-16 HTR', value: 'R_16_TV', sortable: false },
        { text: 'R-17 PBF', value: 'R_17_FV', sortable: false },
        { text: 'R-18 BUCK', value: 'R_18_FCF_1', sortable: false },
        { text: 'R-19 RG', value: 'R_18_FCF_2', sortable: false },
        { text: 'R-20 FCU F4', value: 'R_20_CDF_2', sortable: false },
        { text: 'R-21 NC', value: 'R_21_CDF_1', sortable: false },
        { text: 'Crun status', value: 'Crun_Stat', sortable: false },
        { text: 'SPR status', value: 'RG_Rel_Stat', sortable: false },
        {
          text: 'Minimum ambient temperature',
          value: 'Min_Amb_Tmp',
          sortable: false
        },
        {
          text: 'Minimum ambient temperature threshold',
          value: 'Min_Amb_Tmp_Th',
          sortable: false
        },
        {
          text: 'Solar voltage threshold',
          value: 'Solar_Th_V',
          sortable: false
        },
        { text: 'Reset control register', value: 'RCON', sortable: false },
        { text: 'Boot', value: 'Boot', sortable: false },
        { text: 'Grid run frequency', value: 'G_Run_Frq', sortable: false },
        { text: 'DG run frequency', value: 'DG_Run_Frq', sortable: false },
        { text: 'Solar switch threshold', value: 'Res_P_1', sortable: false },
        {
          text: 'Low batt simultaneous buck on volt threshold',
          value: 'Res_P_2',
          sortable: false
        },
        {
          text: 'Low batt simultaneous buck on time threshold',
          value: 'Res_P_3',
          sortable: false
        },
        { text: 'TV valve on delay', value: 'Res_P_4', sortable: false },
        { text: 'Reserved PIC 5', value: 'Res_P_5', sortable: false },
        { text: 'Reserved PIC 6', value: 'Res_P_6', sortable: false },
        { text: 'Reserved PIC 7', value: 'Res_P_7', sortable: false },
        { text: 'Reserved PIC 8', value: 'Res_P_8', sortable: false },
        { text: 'Reserved PIC 9', value: 'Res_P_9', sortable: false },
        { text: 'Reserved PIC 10', value: 'Res_P_10', sortable: false },
        { text: 'Get TES Tag', value: 'Get_Tag', sortable: false },
        { text: 'TES - 1 sensor TAG ID', value: 'TES_1_Tag', sortable: false },
        { text: 'TES - 2 sensor TAG ID', value: 'TES_2_Tag', sortable: false },
        { text: 'TES - 3 sensor TAG ID', value: 'TES_3_Tag', sortable: false },
        { text: 'TES - 4 sensor TAG ID', value: 'TES_4_Tag', sortable: false },
        { text: 'TES - 5 sensor TAG ID', value: 'TES_5_Tag', sortable: false },
        { text: 'TES - 6 sensor TAG ID', value: 'TES_6_Tag', sortable: false }
      ],
      ecofrostRequiredHeaders: [
        'createdAt',
        'Sys_Num',
        'Uptime',
        'Room_1_H',
        'Room_1_T',
        'Room_2_H',
        'Room_2_T',
        'Amb_H',
        'Amb_T',
        'Crop',
        'Door_Stat',
        'Min_Amb_Tmp',
        'Min_Amb_Tmp_Th',
        'PIC32_Sv',
        'Buck_Sv',
        'PSM',
        'Precooling_M',
        'Set_H',
        'Set_T',
        'Signal_st',
        'Sim_Stat',
        'TSP',
        'VFD_Alm1',
        'VFD_Alm2',
        'VFD_DCV',
        'VFD_DI_Status',
        'VFD_Flt1',
        'VFD_Flt2',
        'VFD_Flt3',
        'VFD_IGBT_Tmp',
        'VFD_OC',
        'VFD_OF',
        'VFD_OP',
        'VFD_Ref_Frq',
        'Water_Lvl_Stat',
        'Weight',
        'Bat_CC',
        'Bat_LC',
        'Bat_V',
        'Boot',
        'Buck_Flt',
        'Buck_HS_Tmp',
        'Buck_IC',
        'Buck_IV',
        'Buck_OC',
        'Com_Stat',
        'Comm_Status',
        'Solar_IC',
        'Solar_IV',
        'Solar_Th_V',
        'R_Ph_V',
        'Y_Ph_V',
        'B_Ph_V',
        'RG_Rel_Stat',
        'Pwr_I',
        'CRUN_Count',
        'Crun_Stat',
        'Dis_P',
        'G_Cnsmptn',
        'G_Run_Frq',
        'Ref_Flt',
        'S_Cnsmptn',
        'Rsn_Lst_Trp',
        'Rst_Reason',
        'R_01',
        'R_02',
        'R_03',
        'R_04',
        'R_05_Buck',
        'R_06',
        'R_07_DG_off',
        'R_08_DG_on',
        'R_09',
        'R_10',
        'R_11',
        'R_12',
        'R_13_HTR',
        'R_14_HUM',
        'R_15_PBF',
        'R_16_TV',
        'R_17_FV',
        'R_18_FCF_1',
        'R_18_FCF_2',
        'R_20_CDF_2',
        'R_21_CDF_1',
        'TES1_T',
        'TES2_T',
        'TES3_T',
        'TES4_T',
        'TES5_T',
        'TES6_T',
        'TES_Charge'
      ]
    };
  }
};
